var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('SiteHeader',{attrs:{"site":_vm.site,"navs":_vm.navs}}),_c('router-view',{attrs:{"site":_vm.site}}),_c('SiteFooter',{attrs:{"site":_vm.site,"navs":_vm.navs}}),_c('FloatingConsult',{attrs:{"phone":_vm.site.phone,"wechatQr":_vm.site.wechatQr,"wechatId":_vm.site.wechatId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }